









import Vue from 'vue';
import Component from 'vue-class-component';

const MainNavigationProps = Vue.extend({
  props: {
    editMode: Boolean,
  },
});

@Component
export default class MainNavigation extends MainNavigationProps {
  get rootClass () {
    return {
      'brandhub-main-navigation--edit-mode': this.editMode,
    };
  }
}
